import { useEffect } from 'react';
import { useDatabase } from '../contexts/DatabaseContext';
import { apiClient } from '../services/apiClient';

/**
 * Хук для отправки несинхронизированных документов при закрытии страницы
 */
export const useBeforeUnload = () => {
  const { repository, isInitialized } = useDatabase();

  useEffect(() => {
    /**
     * Обработчик события beforeunload
     */
    const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
      if (!isInitialized) {
        return;
      }
      
      try {
        // Получаем все документы со статусом 'pending'
        const pendingDocuments = await repository.getDocumentsBySyncStatus('pending');
        
        if (pendingDocuments.length > 0) {
          // Отправляем документы через beacon API
          const success = apiClient.sendBeaconSync(pendingDocuments);
          
          if (success) {
            console.log(`Отправлено ${pendingDocuments.length} документов через beacon`);
          } else {
            console.warn('Не удалось отправить документы через beacon');
          }
        }
      } catch (error) {
        console.error('Ошибка при обработке beforeunload:', error);
      }
    };

    // Регистрируем обработчик события
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Очистка при размонтировании
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [repository, isInitialized]);
}; 